/**
 * Created by steven@coplex.com on 10/4/18.
 */

import { without } from 'lodash';
import { denormalize } from 'normalizr';
import { createSelector } from 'reselect';
import { template as templateSchema } from '../lib/schema.js';
import { CALL_API, HTTP_METHODS } from '../middlewares/api.js';
import { selectCurrentOrganizationId } from './auth.js';
import { deleteEntities, selectEntities } from './entities.js';

// API Actions

const CREATE_TEMPLATE_REQUEST = 'changesync/templates/CREATE_TEMPLATE_REQUEST';
const CREATE_TEMPLATE_SUCCESS = 'changesync/templates/CREATE_TEMPLATE_SUCCESS';
const CREATE_TEMPLATE_FAILURE = 'changesync/templates/CREATE_TEMPLATE_FAILURE';
const RETRIEVE_TEMPLATES_REQUEST =
  'changesync/templates/RETRIEVE_TEMPLATES_REQUEST';
const RETRIEVE_TEMPLATES_SUCCESS =
  'changesync/templates/RETRIEVE_TEMPLATES_SUCCESS';
const RETRIEVE_TEMPLATES_FAILURE =
  'changesync/templates/RETRIEVE_TEMPLATES_FAILURE';
const UPDATE_TEMPLATE_REQUEST = 'changesync/templates/UPDATE_TEMPLATE_REQUEST';
const UPDATE_TEMPLATE_SUCCESS = 'changesync/templates/UPDATE_TEMPLATE_SUCCESS';
const UPDATE_TEMPLATE_FAILURE = 'changesync/templates/UPDATE_TEMPLATE_FAILURE';
const DELETE_TEMPLATE_REQUEST = 'changesync/templates/DELETE_TEMPLATE_REQUEST';
const DELETE_TEMPLATE_SUCCESS = 'changesync/templates/DELETE_TEMPLATE_SUCCESS';
const DELETE_TEMPLATE_FAILURE = 'changesync/templates/DELETE_TEMPLATE_FAILURE';

// Initial State

const initialState = {
  templateIds: [],
};

// Reducer

export default (state = initialState, action) => {
  switch (action.type) {
    case CREATE_TEMPLATE_SUCCESS:
      return {
        ...state,
        templateIds: [...state.templateIds, action.payload.result],
      };
    case RETRIEVE_TEMPLATES_SUCCESS:
      return {
        ...state,
        templateIds: action.payload.result,
      };
    case DELETE_TEMPLATE_SUCCESS:
      return {
        ...state,
        templateIds: without(state.templateIds, action.meta.id),
      };
    default:
      return state;
  }
};

// Action Creators

export const createTemplate = (template) => (dispatch, getState) => {
  const organizationId = selectCurrentOrganizationId(getState());

  return dispatch({
    [CALL_API]: {
      types: [
        CREATE_TEMPLATE_REQUEST,
        CREATE_TEMPLATE_SUCCESS,
        CREATE_TEMPLATE_FAILURE,
      ],
      endpoint: `organizations/${organizationId}/linked_file_templates`,
      method: HTTP_METHODS.POST,
      schema: templateSchema,
      body: { linkedFileTemplate: template },
    },
  });
};

export const retrieveTemplates = () => (dispatch, getState) => {
  const organizationId = selectCurrentOrganizationId(getState());

  return dispatch({
    [CALL_API]: {
      types: [
        RETRIEVE_TEMPLATES_REQUEST,
        RETRIEVE_TEMPLATES_SUCCESS,
        RETRIEVE_TEMPLATES_FAILURE,
      ],
      endpoint: `organizations/${organizationId}/linked_file_templates`,
      method: HTTP_METHODS.GET,
      schema: [templateSchema],
    },
  });
};

export const updateTemplate = (id, template) => ({
  [CALL_API]: {
    types: [
      UPDATE_TEMPLATE_REQUEST,
      UPDATE_TEMPLATE_SUCCESS,
      UPDATE_TEMPLATE_FAILURE,
    ],
    endpoint: `linked_file_templates/${id}`,
    method: HTTP_METHODS.PUT,
    schema: templateSchema,
    body: { linkedFileTemplate: template },
  },
});

export const deleteTemplate = (id) => async (dispatch, getState) => {
  const organizationId = selectCurrentOrganizationId(getState());

  await dispatch({
    [CALL_API]: {
      types: [
        DELETE_TEMPLATE_REQUEST,
        DELETE_TEMPLATE_SUCCESS,
        DELETE_TEMPLATE_FAILURE,
      ],
      endpoint: `organizations/${organizationId}/linked_file_templates/${id}`,
      method: HTTP_METHODS.DELETE,
    },
    meta: { id },
  });

  return dispatch(deleteEntities([`templates.${id}`]));
};

// Selectors

const selectTemplateId = (_, props) => props.templateId;
const selectTemplateIds = (state) => state.templates.templateIds;

export const selectTemplate = createSelector(
  selectTemplateId,
  selectEntities,
  (templateId, entities) => denormalize(templateId, templateSchema, entities)
);

export const selectTemplates = createSelector(
  selectTemplateIds,
  selectEntities,
  (templateIds, entities) =>
    denormalize(templateIds, [templateSchema], entities)
);
